import { request } from '../utils/fetchClient';

export const getImageRelationsByCollectionId = (collectionId, language = null, { limit, offset } = {}) => {
    const params = new URLSearchParams({
        collection_id: collectionId
    });

    if (language && language !== 'all') {
        params.append('language', language);
    }
    if (limit) params.append('limit', limit);
    if (offset) params.append('offset', offset);

    return request(`/image_relations/?${params.toString()}`);
};

export const getImageRelationById = (relationId) =>
    request(`/image_relations/${relationId}`);

export const getSandboxImageRelationById = (relationId) =>
    request(`/image_relations/sandbox/${relationId}`);

export const getImageRelationsByCategory = (collectionId, categoryId, showUnapproved = false, language = null, { limit, offset } = {}) => {
    const params = new URLSearchParams({
        collection_id: collectionId,
        category_id: categoryId
    });

    if (showUnapproved) {
        params.append('show_unapproved', 'true');
    }
    if (language && language !== 'all') {
        params.append('language', language);
    }
    if (limit) params.append('limit', limit);
    if (offset) params.append('offset', offset);

    return request(`/image_relations/by_category?${params.toString()}`);
};

export const getImageRelationsByGroup = (collectionId, groupId, showUnapproved = false, language = null, { limit, offset } = {}) => {
    const params = new URLSearchParams({
        collection_id: collectionId,
        group_id: groupId
    });

    if (showUnapproved) {
        params.append('show_unapproved', 'true');
    }
    if (language && language !== 'all') {
        params.append('language', language);
    }
    if (limit) params.append('limit', limit);
    if (offset) params.append('offset', offset);

    return request(`/image_relations/by_group?${params.toString()}`);
};

export const deleteImageRelation = (relationId) =>
    request(`/image_relations/${relationId}`, { method: 'DELETE' });

// Одобрение открытки (для песочницы - голосование)
export const approveImageRelation = (relationId, userId) => {
	return request(`/image_relations/${relationId}/approve?user_id=${userId}`, {
		method: 'POST'
	});
};

// Отклонение открытки (для песочницы - голосование)
export const rejectImageRelation = (relationId, userId) => {
	return request(`/image_relations/${relationId}/reject?user_id=${userId}`, {
		method: 'POST'
	});
};

// Прямое одобрение открытки модератором (изменение is_approved)
export const moderatorApproveImageRelation = (relationId, userId) => {
	return request(`/image_relations/${relationId}/moderator-approve?user_id=${userId}`, {
		method: 'POST'
	});
};

// Прямое отклонение открытки модератором (изменение is_banned)
export const moderatorRejectImageRelation = (relationId, userId) => {
	return request(`/image_relations/${relationId}/moderator-reject?user_id=${userId}`, {
		method: 'POST'
	});
};

export const getSandboxPostcards = (skip = 0, limit = 100, userId = null) => {
    const params = new URLSearchParams();
    if (skip > 0) params.append('skip', skip);
    if (limit !== 100) params.append('limit', limit);
    if (userId) params.append('user_id', userId);
    
    return request(`/image_relations/sandbox?${params.toString()}`);
};

export const getNextSandboxPostcard = (userId) => {
	return request(`/image_relations/sandbox/next?user_id=${userId}`);
};

export const getNextModeratorPostcard = (userId) => {
	return request(`/image_relations/moderator/next?user_id=${userId}`);
}; 